module.exports = __webpack_public_path__ + "static/24-06b9e69da8fb4bb93997bfbdc98cf6e7.jpg";